module.exports = __webpack_public_path__ + "media/images/icons/download-712b4b1f0b86a65184d8431d8d3c9aac.svg";